// extracted by mini-css-extract-plugin
export var drawerPaper = "_1y-0";
export var itemCard = "_1y-1";
export var itemImage = "_1y-2";